import {appApi} from './api'
import server from './Server'


//请求方法封装
export const request = server
//请求地址
export const api = appApi


